<template>
  <AnalyticsWidget
    title="Production Stage Summary"
    subTitle="Production stage list with panel summary data. Ignores panels on hold"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    :embedded="embedded">
    <template v-slot:title>
      <ActionDropMenu class="float-right">
        <DropdownMenuItem @click="valueDisplayType = 'count'" icon="fa-tally">Show Panel Counts</DropdownMenuItem>
        <DropdownMenuItem @click="valueDisplayType = 'area'" icon="fa-ruler-combined">Show Panel Area</DropdownMenuItem>
      </ActionDropMenu>
    </template>

    <LoadingPanel :loading="loading" />
    <AnalyticsBreakdownTable v-if="!loading">
      <template v-slot:header>
        <tr>
          <th></th>
          <th><Tooltip label="Number of panels requiring this stage but have not reached this stage" helpStyle>Panels Upcoming</Tooltip></th>
          <th><Tooltip label="Number of panels available to begin this stage" helpStyle>Panels Available</Tooltip></th>
          <th><Tooltip label="Number of panels that have started or currently scanned into this stage" helpStyle>Panels Started Stage</Tooltip></th>
          <th><Tooltip label="Number of panels that completed production at this stage today" helpStyle>Panels Completed Today</Tooltip></th>
          <th><Tooltip label="Number of incomplete panels due at this stage today" helpStyle>Pending Panels Due Today</Tooltip></th>
          <th><Tooltip label="Number of incomplete panels overdue at this stage" helpStyle>Pending Panels Overdue</Tooltip></th>
          <th><Tooltip label="Production performance of this stage. Based on overdue panels or panels that completed production today" helpStyle>Avg. Days Behind/Ahead</Tooltip></th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="stageInfo of stageSummaryData" :key="stageInfo.id">
          <td><LinkProductionStage :id="stageInfo.id" :name="stageInfo.name" /></td>
          <template v-if="showPanelCount">
            <td>{{stageInfo.stats.totalUpcomingCount}}</td>
            <td>{{stageInfo.stats.totalAvailableCount}}</td>
            <td>{{stageInfo.stats.totalProductionCount}}</td>
            <td>{{stageInfo.stats.totalCompletedCount}}</td>
            <td>{{stageInfo.stats.totalDueTodayCount}}</td>
            <td>{{stageInfo.stats.totalOverdueCount}}</td>
          </template>
          <template v-if="showPanelArea">
            <td>{{formatDecimal(stageInfo.stats.totalUpcomingArea, 2, true)}}m&sup2;</td>
            <td>{{formatDecimal(stageInfo.stats.totalAvailableArea, 2, true)}}m&sup2;</td>
            <td>{{formatDecimal(stageInfo.stats.totalProductionArea, 2, true)}}m&sup2;</td>
            <td>{{formatDecimal(stageInfo.stats.totalCompletedArea, 2, true)}}m&sup2;</td>
            <td>{{formatDecimal(stageInfo.stats.totalDueTodayArea, 2, true)}}m&sup2;</td>
            <td>{{formatDecimal(stageInfo.stats.totalOverdueArea, 2, true)}}m&sup2;</td>
          </template>
          <td :class="classForStageDaysAhead(stageInfo.stats.avgDaysBehind)">{{formatDecimal(Math.abs(stageInfo.stats.avgDaysBehind), 2, true)}}</td>
        </tr>
      </template>

    </AnalyticsBreakdownTable>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

export default {
  name: 'ProductionStageSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell
  },
  props: {
    filter: Object,
    gridWidth: Number,
    gridHeight: Number,
    embedded: Boolean
  },
  computed: {
    showPanelCount() {
      return this.valueDisplayType == 'count'
    },
    showPanelArea() {
      return this.valueDisplayType == 'area'
    }
  },
  data() {
    return {
      loading: true,
      valueDisplayType: 'count',
      stageSummaryData: {}
    }
  },
  watch: {
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/production/panelschedule', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/production/panelschedule')
  },
  methods: {
    requestData() {
      var params = {
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
      }

      this.$apiService.analyticsService.getProductionStagesSummary(params)
      .then(response => {
        this.stageSummaryData = response.data
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
      })
    },
    classForStageDaysAhead(value) {
      if(value <= 0)
        return 'result-fg-success'

      return 'result-fg-failed'
    }
  }
}
</script>